import type { Invoice } from '@cocoonspace/sdk-js/types/invoice'
import { useState } from 'react'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'

import { InvoiceTableRow } from './invoice-table-row'
import { MonthTableRow } from './month-table-row'
import { useInvoicesFilters } from './use-invoices-filters.hook'

export const InvoiceMonthRow = ({
	month,
	year,
	rows,
	monthTotal,
}: {
	month: number
	year: number
	rows?: Invoice[]
	monthTotal: number
}) => {
	const [filters] = useInvoicesFilters()

	const [isOpen, setIsOpen] = useState(
		month >= dateTimeUtils().get('month') + 1,
	)

	if (!rows?.length) return null

	const monthTotalWithVat = rows.reduce(
		(total, invoice) => total + invoice.amount_with_vat,
		0,
	)

	return (
		<>
			<MonthTableRow
				isOpen={isOpen}
				month={month}
				monthTotal={monthTotal}
				monthTotalWithVat={monthTotalWithVat}
				onClick={() => setIsOpen(!isOpen)}
				year={year}
			/>

			{isOpen &&
				rows
					?.sort((a, b) => {
						if (filters.sortOrder === 'asc') {
							return a.date > b.date ? 1 : -1
						}

						return a.date > b.date ? -1 : 1
					})
					.map((row) => (
						<InvoiceTableRow
							invoice={row}
							key={row.ref}
						/>
					))}
		</>
	)
}
